<div class="outer-container">
  <img  alt="Nomidio" role="heading" src="/assets/default/nomidio/nomidio-blue-green-idaas.svg">

  <ng-content></ng-content>
</div>
